import { render, staticRenderFns } from "./ContactAttributesDialog.vue?vue&type=template&id=2677c6b0&scoped=true&"
import script from "./ContactAttributesDialog.vue?vue&type=script&lang=js&"
export * from "./ContactAttributesDialog.vue?vue&type=script&lang=js&"
import style0 from "./ContactAttributesDialog.vue?vue&type=style&index=0&id=2677c6b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2677c6b0",
  null
  
)

export default component.exports